module.exports = { id: "flickr", url: "/build/app/img/symbols.svg#flickr", viewBox: "", toString: function() { return this.url; } };